/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import { GoogleLogin } from "react-google-login";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import cogoToast from "cogo-toast";
import CustomSelect from "../../../../components/CustomSelect";
import { getCountryAction } from "../../../../redux/actions/countryActions";

import TermsAndConditions from "../../../../components/TermsAndConditions";

import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
} from "@material-ui/core";
import AuthWrapper from "../AuthWrapper";
// import GoogleIcon from "../../../../assets/icons/google-icon.svg";
import WBlogo from "../../../../assets/icons/WBlogo.svg";
import EyeIcon from "../../../../assets/icons/eye.svg";
import { isValidEmail, redirectToStoredPathAfterLogin } from "../../../../utils/helpers";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import SlidingPane from "react-sliding-pane";
import { getStateAction } from "../../../../redux/actions/stateActions";
import httpRequest from "../../../../ajax";

// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// import clsx from "clsx";
import {
  activateUserAction,
  createUserAction,
  resendOTPAction,
  // socialMediaRegister,
} from "../../../../redux/actions/authActions";
import {
  AUTH_LOADING,
  CLEAR_CREATE_USER,
  GET_STATES,
  STOP_AUTH_LOADING,
} from "../../../../redux/actionTypes";
import { Height } from "@material-ui/icons";
// import { FacebookIcon, LinkedinIcon } from "react-share";
// import LinkedIn from "linkedin-login-for-react";
const SignUp = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [code, setCode] = useState("");
  const [showTermsError, setShowTermsError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState();
  const [actEmail, setActEmail] = useState("");
  const [activationError, setActivationError] = useState("");
  const [showActivationForm, setShowActivationForm] = useState(false);
  const { inviteCode } = useParams();
  const [state, setState] = useState({
    username: "",
    email: "",
    password: "",
    account_type: "referral",
    country_id: selectedCountry || 0,
    invited_by_code: inviteCode || "",
    agree: false,
    intent: sessionStorage.getItem("intent") || "",
  });
  const { country, profile } = useSelector((store) => store);
  const { loading, userCreated, isAuthenticated } = useSelector(
    (store) => store.auth
  );
  const { countries } = country;
  const [passwordError, setPasswordError] = useState("");
  const [passwordStrength, setPasswordStrength] = useState({
    score: 0,
    label: "",
    color: "#dc3545",
  });
  const [showWaitlist, setShowWaitlist] = useState(false);
  const [waitlistEmail, setWaitlistEmail] = useState("");
  const [waitlistError, setWaitlistError] = useState("");
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistCountry, setWaitlistCountry] = useState("");
  const [showBusinessMessage, setShowBusinessMessage] = useState(false);

  useEffect(() => {
    dispatch({ type: CLEAR_CREATE_USER });
    dispatch(getCountryAction);

    const fetchWaitlistConfig = async () => {
      try {
        const {
          data: { data },
        } = await httpRequest("get", "/waitlist/should-show");

        if (typeof data?.show_waitlist === "boolean") {
          // setShowWaitlist(true);
          setShowWaitlist(data.show_waitlist);
        }
      } catch (error) {
        // if the config endpoint fails, fall back to showing waitlist by default
        setShowWaitlist(true);
      }
    };

    // fetchWaitlistConfig();
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) history.push("/");
  }, [isAuthenticated, history]);

  useEffect(() => {
    // Show activation form if user is created or URL includes activate
    setShowActivationForm(userCreated || pathname.includes("activate"));
  }, [userCreated, pathname]);

  const switchToBusiness = () => {
    setShowBusinessMessage(true);
  };

  const [termsofuse, setTermsOfUse] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [checkedTerms, setCheckedTerms] = useState(false);

  const validatePassword = (password) => {
    if (!password) return "Password is required";
    if (password.length < 8)
      return "Password must be at least 8 characters long";
    if (!/[A-Z]/.test(password))
      return "Password must contain at least one uppercase letter";
    if (!/[0-9]/.test(password))
      return "Password must contain at least one number";
    if (!/[a-zA-Z]/.test(password))
      return "Password must contain at least one letter";
    return "";
  };

  const getPasswordStrength = (password) => {
    let score = 0;
    if (!password) return { score: 0, label: "", color: "#dc3545" };
    if (password.length >= 8) score += 1;
    if (/[a-z]/.test(password)) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;

    let label = "Weak";
    let color = "#dc3545"; // red
    if (score >= 4) {
      label = "Strong";
      color = "#28a745"; // green
    } else if (score === 3) {
      label = "Good";
      color = "#ffc107"; // amber
    } else if (score === 2) {
      label = "Fair";
      color = "#fd7e14"; // orange
    }

    return { score, label, color };
  };

  const handleChange = ({ target: { id, value } }) => {
    const newValue = {};
    newValue[id] = value;

    if (id === "password") {
      const error = validatePassword(value);
      setPasswordError(error);
      setPasswordStrength(getPasswordStrength(value));
    }

    setState({ ...state, ...newValue });
  };

  const handleWaitlistSubmit = async (e) => {
    e.preventDefault();
    setWaitlistError("");
    setWaitlistSuccess(false);

    const trimmedEmail = waitlistEmail.trim();

    if (!trimmedEmail) {
      setWaitlistError("Please enter your email address");
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      setWaitlistError("Please enter a valid official email address");
      return;
    }

    setWaitlistEmail(trimmedEmail);

    setWaitlistLoading(true);

    try {
      const payload = { email: trimmedEmail };
      if (waitlistCountry) {
        payload.country = waitlistCountry;
      }
      await httpRequest("post", "/waitlist", payload);
      setWaitlistSuccess(true);
      cogoToast.success("You're on the list! We'll be in touch soon.");
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to join the waitlist. Please try again.";
      setWaitlistError(message);
      cogoToast.error(message);
    } finally {
      setWaitlistLoading(false);
    }
  };

  const handleWaitlistEmailChange = ({ target: { value } }) => {
    setWaitlistEmail(value);

    if (waitlistError) {
      setWaitlistError("");
    }

    if (waitlistSuccess) {
      setWaitlistSuccess(false);
    }
  };

  const handleWaitlistCountryChange = ({ target: { value } }) => {
    setWaitlistCountry(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checkedTerms) {
      setShowTermsError(true);
      return;
    }

    const passwordValidationError = validatePassword(state.password);
    if (passwordValidationError) {
      setPasswordError(passwordValidationError);
      return;
    }

    if (!isValidEmail(state.email)) {
      return;
    }

    dispatch({ type: AUTH_LOADING });
    setActEmail(state.email);

    try {
      const response = await createUserAction(state, dispatch);

      // createUserAction returns an action; on failure it returns { type: 'ERROR', payload: message }
      if (response && response.type === "ERROR") {
        const msg =
          response.payload || "Failed to create account. Please try again.";
        cogoToast.error(msg);
        return;
      }

      // success — notify user that activation code has been sent
      cogoToast.success(`Activation code sent to ${state.email}`);

      setState({
        username: "",
        password: "",
        country_id: selectedCountry,
        invited_by_code: inviteCode || "",
      });
      setShowActivationForm(true);
    } catch (err) {
      const msg = err?.message || "Failed to sign up. Please try again.";
      cogoToast.error(msg);
    } finally {
      dispatch({ type: STOP_AUTH_LOADING });
    }
  };

  const handleActivate = async (e) => {
    e.preventDefault();
    setActivationError("");

    if (!code.trim()) {
      setActivationError("Please enter activation code");
      return;
    }

    dispatch({ type: AUTH_LOADING });

    try {
      const response = await activateUserAction(dispatch, code);

      // activateUserAction resolves to an action. On failure it returns { type: "ERROR", payload: message }
      if (response && response.type === "ERROR") {
        const msg =
          response.payload || "Failed to activate account. Please try again.";
        cogoToast.error(msg);
        setActivationError(msg);
        dispatch({ type: STOP_AUTH_LOADING });
        return;
      }

      // success
      cogoToast.success("Account activated successfully");
      localStorage.setItem("accountType", "referral");

      // give toast a moment to show before navigation
      await new Promise((resolve) => setTimeout(resolve, 700));

      redirectToStoredPathAfterLogin(history, localStorage.getItem("accountType"));
    } catch (error) {
      const msg =
        error?.message || "Failed to activate account. Please try again.";
      cogoToast.error(msg);
      setActivationError(msg);
      dispatch({ type: STOP_AUTH_LOADING });
    }
  };

  const handleResendOTP = async () => {
    if (!actEmail) {
      setActivationError("Email not found. Please try signing up again.");
      return;
    }

    dispatch({ type: AUTH_LOADING });
    try {
      await resendOTPAction({ email: actEmail }, dispatch);
      setActivationError("New activation code has been sent to your email.");
    } catch (error) {
      setActivationError("Failed to resend activation code. Please try again.");
    } finally {
      dispatch({ type: STOP_AUTH_LOADING });
    }
  };

  const handleChangeCountry = ({ target: { value } }) => {
    const countryID = value;
    setSelectedCountry(countryID);
    setState({ ...state, country_id: countryID });
  };

  // const responseGoogle = (response) => {
  //   if (response.error) return;
  //   const { accessToken, profileObj } = response;

  //   const payload = {};
  //   payload["email"] = profileObj.email;
  //   payload["platform_uid"] = profileObj.googleId;
  //   payload["platform"] = "google";
  //   payload["first_name"] = profileObj.givenName;
  //   payload["last_name"] = profileObj.familyName;
  //   payload["fcm_token"] = accessToken;
  //   payload["invited_by_code"] = "";

  //   dispatch({ type: AUTH_LOADING });
  //   Promise.resolve(socialMediaRegister(payload, dispatch))
  //     .then(() =>
  //       setState({
  //         username: "",
  //         email: "",
  //         password: "",
  //         invited_by_code: inviteCode || "",
  //       })
  //     )
  //     .finally(() => {
  //       dispatch({ type: STOP_AUTH_LOADING });
  //     });
  // };

  // const responseFacebook = (response) => {
  //   if (response.status === "connected") {
  //     const payload = {};
  //     payload["email"] = response.data.email;
  //     payload["platform_uid"] = "facebook-id";
  //     payload["platform"] = "facebook";
  //     payload["first_name"] = response.data.name;
  //     payload["last_name"] = response.data.name;
  //     payload["fcm_token"] = "accessToken";
  //     payload["invited_by_code"] = inviteCode || "";
  //     payload["response"] = response;

  //     dispatch({ type: AUTH_LOADING });
  //     Promise.resolve(socialMediaRegister(payload, dispatch))
  //       .then(() => {})
  //       .finally(() => {
  //         dispatch({ type: STOP_AUTH_LOADING });
  //       });
  //   }
  // };
  // const callbackLinkedIn = (error, code, redirectUri) => {
  //   console.log(code, redirectUri);
  //   if (error) {
  //     // signin failed
  //   } else {
  //     // Obtain authorization token from linkedin api
  //     // see https://developer.linkedin.com/docs/oauth2 for more info
  //   }

  // {(userCreated || pathname.includes("activate")) && (
  // };

  // if (showWaitlist) {
  //   return (
  //     <div className="waitlist-wrapper">
  //       <div className="waitlist-hero">
  //         <span className="waitlist-badge">workbrook Referral</span>
  //         <h2 className="waitlist-title">
  //           Be the first to experience workbrook Referral
  //         </h2>
  //         <p className="waitlist-subtitle">
  //           We are putting final touches on a vibrant referral community. Secure
  //           your spot and we will reach out the moment the experience goes live.
  //         </p>

  //         <div className="waitlist-highlights">
  //           <div className="waitlist-highlight-card">
  //             <h5>Curated Matches</h5>
  //             <p>
  //               Unlock exclusive referral opportunities tailored for high-impact
  //               talent.
  //             </p>
  //           </div>
  //           <div className="waitlist-highlight-card">
  //             <h5>Insider Community</h5>
  //             <p>
  //               Join a circle of professionals shaping the future of workbrook
  //               Referral.
  //             </p>
  //           </div>
  //           <div className="waitlist-highlight-card">
  //             <h5>Launch Priority</h5>
  //             <p>
  //               Be the first to know about new drops, feature previews, and
  //               launch events.
  //             </p>
  //           </div>
  //         </div>
  //       </div>

  //       {/* <div className="waitlist-card">
  //         <img src={WBlogo} alt="workbrook logo" className="waitlist-logo" />
  //         <h3>Join the waitlist</h3>
  //         <p className="waitlist-copy">
  //           Share your official email so we can reserve your spot for the grand
  //           reveal.
  //         </p>

  //         {waitlistSuccess ? (
  //           <div className="waitlist-success">
  //             <p>
  //               Thank you! We have saved <strong>{waitlistEmail}</strong>. Keep
  //               an eye on your inbox for next steps.
  //             </p>
  //             <CustomButton
  //               backgroundColor="#3A6ED4"
  //               color="#fff"
  //               text="Continue to Sign Up"
  //               handleClick={() => setShowWaitlist(false)}
  //               additionalClass="mt-4"
  //             />
  //           </div>
  //         ) : (
  //           <form onSubmit={handleWaitlistSubmit} className="waitlist-form">
  //             <p style={{ color: "#656b74", marginBottom: "8px" }}>Country</p>
  //             <Select
  //               labelId="waitlist_country_id"
  //               name="waitlist_country"
  //               label="country"
  //               value={waitlistCountry}
  //               onChange={handleWaitlistCountryChange}
  //               className="fullwidth-select"
  //             >
  //               <MenuItem value="">Select a country</MenuItem>
  //               {countries.map(({ name, id }) => (
  //                 <MenuItem key={id} value={name}>
  //                   {name}
  //                 </MenuItem>
  //               ))}
  //             </Select>

  //             <CustomInput
  //               onChange={handleWaitlistEmailChange}
  //               type="email"
  //               label="Official Email Address"
  //               id="waitlist_email"
  //               value={waitlistEmail}
  //               error={waitlistError}
  //               isRequired
  //             />

  //             <CustomButton
  //               type="submit"
  //               backgroundColor="#3A6ED4"
  //               color="#fff"
  //               text="Notify Me"
  //               loading={waitlistLoading}
  //               additionalClass="mt-4"
  //             />
  //           </form>
  //         )}

  //         {!waitlistSuccess && (
  //           <CustomButton
  //             type="button"
  //             text="Skip to Sign Up"
  //             backgroundColor="transparent"
  //             color="#3A6ED4"
  //             borderColor="transparent"
  //             handleClick={() => setShowWaitlist(false)}
  //             additionalClass="mt-3 waitlist-skip"
  //           />
  //         )}
  //       </div> */}
  //     </div>
  //   );
  // }

  return (
    <AuthWrapper>
      <div className="form-container d-flex justify-content-center">
        {showActivationForm ? (
          <div className="auth-form signup-form ml-md-4">
            <h4 className="text-center mt-4">Enter Activation Code</h4>
            <p className="text-center">
              <small>Check your email inbox/spam for the activation code</small>
            </p>

            {activationError && (
              <p className="text-danger text-center">{activationError}</p>
            )}

            <form onSubmit={handleActivate} className="pt-2 pb-5">
              <CustomInput
                onChange={(e) => setCode(e.target.value)}
                type="text"
                label="Activation Code"
                id="icode"
                value={code}
                isRequired
              />

              <CustomButton
                type="submit"
                backgroundColor="#3A6ED4"
                color="#fff"
                text="Activate"
                loading={loading}
                additionalClass="my-5"
              />

              <div className="d-flex justify-content-center">
                <CustomButton
                  type="button"
                  color="blue"
                  text="Resend Code"
                  additionalClass="no-border"
                  handleClick={handleResendOTP}
                  disabled={loading}
                />
              </div>
            </form>
          </div>
        ) : showBusinessMessage ? (
          <div className="auth-form ml-md-4 my-5">
            <div className="business-coming-soon">
              <div className="business-header pt-5">
                {/* <img
                  src={WBlogo}
                  alt="workbrook Business"
                  className="business-logo"
                /> */}
                <h3 className="business-title">workbrook Business Solutions</h3>
              </div>

              <div className="business-content">
                <p className="business-tagline">
                  Partner with workbrook to power your hiring
                </p>

                <p className="business-description">
                  Looking to register your business and unlock the full
                  potential of workbrook Business Solutions? We are here to help
                  you streamline recruitment, engage talent, and grow with
                  confidence.
                </p>

                <div className="business-cta">
                  <h4 className="cta-title">Reach out to our Business Team</h4>
                  <p className="cta-description">
                    For registration and tailored support, please contact us
                    directly at:
                  </p>
                  <a
                    href="mailto:business@workbrook.com"
                    className="business-email"
                  >
                    business@workbrook.com
                  </a>
                  <p className="cta-footer">
                    Our team will walk you through the setup process, answer
                    your questions, and ensure your business gets the most out
                    of workbrook.
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => setShowBusinessMessage(false)}
                style={{ color: "#3A6ED4", fontWeight: "500" }}
              >
                ← Back to Sign Up
              </button>
            </div>
          </div>
        ) : (
          <div className="auth-form ml-md-4">
            <h4 className="text-center mt-4">Sign Up</h4>

            <CustomButton
              icon={WBlogo}
              alt="logo"
              backgroundColor="black"
              color="#fff"
              text="Switch to workbrook Business"
              additionalClass="mt-3 mb-5"
              handleClick={() => switchToBusiness()}
            />
            <form onSubmit={handleSubmit}>
              {showTermsError && !checkedTerms && (
                <p style={{ color: "red" }}>
                  Please agree with terms and condition before proceeding
                </p>
              )}
              <CustomInput
                onChange={handleChange}
                type="text"
                label="Username"
                id="username"
                value={state.username}
              />

              <CustomInput
                onChange={handleChange}
                type="text"
                label="Email"
                id="email"
                value={state.email}
                error={
                  state.email && !isValidEmail(state.email)
                    ? "Please enter a valid email address"
                    : ""
                }
              />

              <p style={{ color: "#656b74" }}>Country</p>

              <Select
                labelId="country_id"
                name="country"
                label="country"
                value={state.country_id}
                onChange={handleChangeCountry}
                className="fullwidth-select"
              >
                <MenuItem value="">Select an country</MenuItem>
                {countries.map(({ name, id }) => (
                  <MenuItem key={id} value={id}>
                    {name}
                  </MenuItem>
                ))}
              </Select>

              <CustomInput
                tooltipText="Password must contain at least 8 characters, one uppercase letter, and one number"
                onChange={handleChange}
                type="password"
                label="Password"
                id="password"
                value={state.password}
                icon={EyeIcon}
                error={passwordError}
              />

              {state.password && (
                <div className="mt-2" aria-live="polite">
                  <div
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={5}
                    aria-valuenow={passwordStrength.score}
                    className="w-100"
                    style={{
                      height: 6,
                      background: "#e9ecef",
                      borderRadius: 3,
                    }}
                  >
                    <div
                      style={{
                        width: `${(passwordStrength.score / 5) * 100}%`,
                        height: 6,
                        background: passwordStrength.color,
                        borderRadius: 3,
                        transition: "width 200ms ease",
                      }}
                    />
                  </div>
                  <small
                    className="d-block mt-1"
                    style={{ color: passwordStrength.color }}
                  >
                    Password strength: {passwordStrength.label}
                  </small>
                </div>
              )}

              {pathname.includes("activate") && (
                <CustomInput
                  isDisabled={inviteCode}
                  onChange={handleChange}
                  type="text"
                  label="Invite Code"
                  id="invited_by_code"
                  value={state.invited_by_code}
                />
              )}

              <div className="d-flex align-items-center mt-3 small-text">
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      id="terms"
                      name="terms"
                      onChange={(e) => setCheckedTerms(e.target.checked)}
                      checked={checkedTerms}
                    />
                  }
                  label={
                    <span>
                      By Signing up, I agree to the{" "}
                      <a
                        href="#"
                        style={{ fontWeight: "bold" }}
                        onClick={(e) => {
                          e.preventDefault();
                          setTermsOfUse({ isPaneOpen: true });
                        }}
                      >
                        Terms of Use
                      </a>{" "}
                      of this application
                      {showTermsError && !checkedTerms && (
                        <small className="text-danger d-block">
                          You must agree to the Terms of Use to sign up.
                        </small>
                      )}
                    </span>
                  }
                />
              </div>

              <p className="pt-1 pb-1 mb-0 small-text text-center">
                You can also get familiar with our{" "}
                <a
                  href="https://workbrook.com/workbrook-privacy-policy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>{" "}
              </p>

              <CustomButton
                type="submit"
                backgroundColor="#3A6ED4"
                color="#fff"
                text="Sign Up"
                loading={loading}
                disabled={
                  loading ||
                  !isValidEmail(state.email) ||
                  !checkedTerms ||
                  !state.password ||
                  !!passwordError ||
                  getPasswordStrength(state.password).score < 3
                }
                additionalClass="my-5"
              />
            </form>
            <p className="small-text text-center" style={{ fontSize: 14 }}>
              <Link to="/match-score">
                Preview your match score without signing up
              </Link>
            </p>
            <p className="pb-5 small-text text-center">
              Already have an account? <Link to="/signin">Sign In</Link>{" "}
            </p>
          </div>
        )}

        <SlidingPane
          overlayClassName="some-custom-overlay-class2"
          isOpen={termsofuse.isPaneOpen}
          title="Terms of Use"
          subtitle="workbrook"
          width="100%"
          from="bottom"
          onRequestClose={() => setTermsOfUse({ isPaneOpen: false })}
        >
          <TermsAndConditions />
          <button
            className="i-agree"
            onClick={() => {
              setCheckedTerms(true);
              setTermsOfUse({ isPaneOpen: false });
            }}
          >
            I AGREE
          </button>
        </SlidingPane>
      </div>
    </AuthWrapper>
  );
};

export default SignUp;
